export default __webpack_public_path__ + "static/media/2.381c4daa.png";